import { Button, message, Select, Space, Table } from "antd"
import { useEffect, useState } from "react"
import { useParams } from "react-router"
import { baseAxiosNoInfo, baseAxiosComplete } from "../../tool/axios"
import CustomerMenu from "./CustomerMenu"
import './css/MenuTemplate.css'

const { Option } = Select
const { Column } = Table

type backendStepDataType = {
    stage_number: number | undefined,
    stage_desc: string | undefined,
    high_price_item_count: number,
    detail: {
        which_date: string
        which_day: number,
        meal_times: number,
        menu_item_list: {
            is_high_price: number | undefined,
            menu_item_name: string | undefined,
            menu_item_id: string | undefined,
            menu_item_count: number
        }[]
    }[]
}[]

type itemRow = {
    is_high_price: number | undefined,
    menu_item_name: string | undefined,
    menu_item_id: string | undefined,
    menu_item_count: number
}

type reviewType = {
    stageDesc: string | undefined
    detail: {
        date: string,
        meals1: itemRow[],
        meals2: itemRow[],
        meals3: itemRow[],
        meals4: itemRow[],
        meals5: itemRow[],
        meals6: itemRow[],
    }[]
}

export default function () {

    const params: { check_in_id: string } = useParams()
    const [hadFill, setHadFill] = useState<number>(0)
    const [showEditPage, setShowEditPage] = useState<boolean>(false)
    const [showHistoryPage, setShowHistoryPage] = useState<boolean>(false)
    const [standardMeals, setStandardMeals] = useState<{
        template_id: string, template_name: string
    }[]>([])
    const [standanrdApplyID, setStandanrdApplyID] = useState<string>() // 标准餐单id
    const [standardMealsData, setSandardMealsData] = useState<backendStepDataType[]>()
    const [currentStageIndex, setCurrentStageIndex] = useState<number>(0)

    const [reviewData, setReviewData] = useState<reviewType[]>([])

    // 是否触发修改更换菜单
    const [hasReplaceMenuItem, setHasReplaceMenuItem] = useState<boolean>(false)

    let everyDayMeals = {
        meals1: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals2: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals3: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals4: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals5: [
            {
                foodName: '',
                count: 0
            }
        ],
        meals6: [
            {
                foodName: '',
                count: 0
            }
        ],
    }

    function historyToRenderData(data: backendStepDataType): reviewType[] {
        let result: reviewType[] = []

        for (let i = 0; i < data.length; i++) {
            let dayDetailArr: any = []

            for (let j = 0; j < data[i].detail.length; j++) {
                let iDetail = data[i].detail[j]
                if (!(dayDetailArr.some((el: any) => el.date === iDetail.which_date))) {
                    let meals1: itemRow[] = []
                    let meals2: itemRow[] = []
                    let meals3: itemRow[] = []
                    let meals4: itemRow[] = []
                    let meals5: itemRow[] = []
                    let meals6: itemRow[] = []
                    if (iDetail.meal_times === 1) {
                        meals1 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 2) {
                        meals2 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 3) {
                        meals3 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 4) {
                        meals4 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 5) {
                        meals5 = iDetail.menu_item_list
                    }
                    if (iDetail.meal_times === 6) {
                        meals6 = iDetail.menu_item_list
                    }
                    dayDetailArr.push({
                        date: data[i].detail[j].which_date,
                        meals1,
                        meals2,
                        meals3,
                        meals4,
                        meals5,
                        meals6,
                    })
                } else {
                    let hadIndex = dayDetailArr.findIndex(((el: any) => el.date === iDetail.which_date))
                    dayDetailArr[hadIndex]['meals' + iDetail.meal_times].push(...iDetail.menu_item_list)
                }
            }

            result.push({
                stageDesc: data[i].stage_desc,
                detail: dayDetailArr
            })
        }
        return result
    }

    useEffect(() => {
        // 查询是否有餐单记录
        baseAxiosNoInfo('/cooking_center/customer/menu/has_menu', {
            params: {
                check_in_id: params.check_in_id
            }
        }).then((res: any) => {
            setHadFill(res)
            if (res === 1) { // 有记录则查询详情
                baseAxiosNoInfo('/cooking_center/customer/menu/detail', {
                    params: {
                        check_in_id: params.check_in_id
                    }
                }).then((res2: any) => {
                    console.clear()
                    console.log(res2, 'useEffect')
                    setShowHistoryPage(true)
                    setReviewData(historyToRenderData(res2.stage))
                    setSandardMealsData(res2.stage)
                    setHasReplaceMenuItem(res2.has_replace_menu_item == 1 ? true : false)
                })
            }
        })

        // 查询标准餐单列表
        baseAxiosNoInfo('/cooking_center/customer/menu/template_menu_list', {
            params: {
                check_in_id: params.check_in_id
            }
        }).then((res: any) => {
            res && setStandardMeals(res)
        })
    }, [])

    return <div>
        {/* 已经存在数据，显示创建好的餐单 */}
        {hadFill === 1 && <div style={{
            background: '#fff', marginTop: 16, padding: 16
        }}>
            <Button size="small" onClick={() => { window.history.go(-1) }} style={{ marginBottom: 16 }}>返回</Button>
            {showHistoryPage && <div>
                <Space>
                    <Space className="food-jd-tabs">
                        {reviewData.map((el: any, index: number) => <Button style={{
                            background: index === currentStageIndex ? '#2a2abc' : 'none',
                            color: index === currentStageIndex ? '#fff' : '#333',
                        }} onClick={() => {
                            setCurrentStageIndex(index)
                        }}>第{index + 1}阶段</Button>)}
                    </Space>
                    <Button onClick={() => {
                        setShowEditPage(true)
                        setShowHistoryPage(false)
                    }}>编辑餐单</Button>
                    <Button title="只能清空未开始日期" onClick={() => {
                        baseAxiosComplete.post('/cooking_center/customer/menu/clean', {
                            check_in_id: params.check_in_id
                        }).then(res => {
                            baseAxiosNoInfo('/cooking_center/customer/menu/has_menu', {
                                params: {
                                    check_in_id: params.check_in_id
                                }
                            }).then((res: any) => {
                                setHadFill(res)
                                if (res === 1) { // 有记录则查询详情
                                    baseAxiosNoInfo('/cooking_center/customer/menu/detail', {
                                        params: {
                                            check_in_id: params.check_in_id
                                        }
                                    }).then((res2: any) => {
                                        setShowHistoryPage(true)
                                        setReviewData(historyToRenderData(res2.stage))
                                        setSandardMealsData(res2.stage)
                                    })
                                }
                            })
                        })
                    }}>清空餐单</Button>
                </Space>

                <div className="food-jd-content">
                    <p style={{ marginTop: '10px' }}>{reviewData[currentStageIndex] && reviewData[currentStageIndex].stageDesc}</p>
                    {/* <Space style={{ marginBottom: '10px' }}>
                        <Space>
                            <div className="rect" style={{ width: '15px', height: '15px', background: 'orange' }}></div>
                            已食用
                        </Space>
                        <Space>
                            <div className="rect" style={{ width: '15px', height: '15px', background: 'green' }}></div>
                            明日
                        </Space>
                        <Space>
                            <div className="rect" style={{ width: '15px', height: '15px', background: '#fff', border: '1px solid #666', boxSizing: 'border-box' }}></div>
                            未食用
                        </Space>
                    </Space> */}
                    <Table pagination={false} dataSource={[
                        { mealName: '早餐(8:00)' },
                        { mealName: '加餐(10:00)' },
                        { mealName: '午餐(12:00)' },
                        { mealName: '间餐(15:00)' },
                        { mealName: '晚餐(18:00)' },
                        { mealName: '宵夜(20:00)' },
                    ]}>
                        <Column title="餐次" dataIndex="mealName"></Column>

                        {reviewData[currentStageIndex] && reviewData[currentStageIndex].detail.map(((el: any) => <Column title={el.date} render={(row: any) => {
                            if (row.mealName === '早餐(8:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals1.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                            if (row.mealName === '加餐(10:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals2.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                            if (row.mealName === '午餐(12:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals3.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                            if (row.mealName === '间餐(15:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals4.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                            if (row.mealName === '晚餐(18:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals5.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                            if (row.mealName === '宵夜(20:00)') {
                                return <ul style={{ padding: 0, margin: 0, listStyle: 'none' }}>
                                    {el.meals6.map((el: any) => <li><Space>{el.is_high_price === 1 && <span style={{ color: 'orange' }}>(贵)</span>}<span>{el.menu_item_name}（{el.menu_item_count}）</span></Space></li>)}
                                </ul>
                            }
                        }}></Column>))}
                    </Table>
                </div>
            </div>}
        </div>}

        {/* 不存在数据，显示创建空白餐单按钮和选择某个餐单模板下拉 */}
        {hadFill === 0 && <div style={{
            background: '#fff', marginTop: 16, padding: 16
        }}>
            <Button size="small" onClick={() => { window.history.go(-1) }} style={{ marginBottom: 16 }}>返回</Button>
            <h3>该客户未创建餐单，请先创建或应用标准餐单</h3>
            <Space>
                <Button onClick={() => {
                    setSandardMealsData(undefined)
                    setStandanrdApplyID(undefined)
                    setShowEditPage(true)
                }}>创建空白餐单</Button>
                <Select style={{ minWidth: 200 }} placeholder="应用标准餐单" value={standanrdApplyID} onChange={(id: string) => {
                    setStandanrdApplyID(id)
                    baseAxiosNoInfo.get('/cooking_center/customer/menu/use_template_menu', {
                        params: {
                            template_id: id,
                            check_in_id: params.check_in_id
                        }
                    }).then((res: any) => {
                        if (res) {
                            setShowEditPage(true)
                            setSandardMealsData(res.stage)
                        }
                    })
                }}>
                    {standardMeals.map(el => <Option value={el.template_id} key={el.template_id}>{el.template_name}</Option>)}
                </Select>
            </Space>

        </div>}

        {/* 切换到编辑菜单组件 */}
        {showEditPage && <div style={{ background: '#fff', padding: 16 }}>
            <CustomerMenu
                had_fill={hadFill}
                check_in_id={params.check_in_id}
                template_id={standanrdApplyID}
                hasReplaceMenuItem={hasReplaceMenuItem}
                stage={standardMealsData}
                onFinish={() => {
                    baseAxiosNoInfo('/cooking_center/customer/menu/has_menu', {
                        params: {
                            check_in_id: params.check_in_id
                        }
                    }).then((res: any) => {
                        setHadFill(res)
                        if (res === 1) { // 有记录则查询详情
                            baseAxiosNoInfo('/cooking_center/customer/menu/detail', {
                                params: {
                                    check_in_id: params.check_in_id
                                }
                            }).then((res2: any) => {
                                setShowEditPage(false)
                                setShowHistoryPage(true)
                                setReviewData(historyToRenderData(res2.stage))
                                setSandardMealsData(res2.stage)
                            })
                        }
                    })
                }}
            />
        </div>}
    </div>
}